import React, { useCallback, useState, useEffect } from "react";
import CaseCardOutline from "./CaseCardOutline";
import Header from "./Header";
import Footer from "./Footer";
import PlainButton from "../common/PlainButton";
import PlotViewLoadingComponent from "../loading/PlotViewLoadingComponent.jsx";

const ElemPlayEditableBanner = function ({ onClick }) {
    return (
        <div className="tde-elem-play-editable-banner">
            <div>
                <h2 className="tde-mx-3">
                    Click{" "}
                    <svg
                        width="54"
                        height="82"
                        viewBox="0 0 54 82"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="tde-mx-3"
                        onClick={onClick}
                        tabIndex={0}
                    >
                        <rect
                            x="4"
                            y="2"
                            width="50"
                            height="80"
                            rx="12"
                            fill="#F6CBD6"
                        />
                        <rect
                            x="0.5"
                            y="0.5"
                            width="51"
                            height="79"
                            rx="11.5"
                            fill="#FBEAEF"
                            stroke="#A71931"
                        />
                        <path
                            d="M24.48 40.88V35.03H19.02V33.17H24.48V27.32H26.43V33.17H31.89V35.03H26.43V40.88H24.48Z"
                            fill="#A71931"
                        />
                        <path
                            d="M7.233 63.963L6.892 65.063H9.059L8.718 63.963C8.586 63.5597 8.46133 63.16 8.344 62.764C8.22667 62.3607 8.10933 61.95 7.992 61.532H7.948C7.838 61.95 7.72433 62.3607 7.607 62.764C7.48967 63.16 7.365 63.5597 7.233 63.963ZM5.033 68L7.475 60.784H8.509L10.951 68H9.972L9.29 65.8H6.661L5.968 68H5.033ZM13.418 68.132C13.132 68.132 12.89 68.088 12.692 68C12.5013 67.912 12.3437 67.791 12.219 67.637C12.1017 67.483 12.0173 67.296 11.966 67.076C11.9147 66.856 11.889 66.614 11.889 66.35V63.391H11.097V62.709L11.933 62.654L12.043 61.158H12.802V62.654H14.243V63.391H12.802V66.361C12.802 66.691 12.8607 66.9477 12.978 67.131C13.1027 67.307 13.319 67.395 13.627 67.395C13.7223 67.395 13.825 67.3803 13.935 67.351C14.045 67.3217 14.144 67.2887 14.232 67.252L14.408 67.934C14.2613 67.9853 14.1 68.0293 13.924 68.066C13.7553 68.11 13.5867 68.132 13.418 68.132ZM16.92 68.132C16.634 68.132 16.392 68.088 16.194 68C16.0033 67.912 15.8456 67.791 15.721 67.637C15.6036 67.483 15.5193 67.296 15.468 67.076C15.4166 66.856 15.391 66.614 15.391 66.35V63.391H14.599V62.709L15.435 62.654L15.545 61.158H16.304V62.654H17.745V63.391H16.304V66.361C16.304 66.691 16.3626 66.9477 16.48 67.131C16.6046 67.307 16.821 67.395 17.129 67.395C17.2243 67.395 17.327 67.3803 17.437 67.351C17.547 67.3217 17.646 67.2887 17.734 67.252L17.91 67.934C17.7633 67.9853 17.602 68.0293 17.426 68.066C17.2573 68.11 17.0886 68.132 16.92 68.132ZM18.9538 68V62.654H19.7018L19.7788 63.622H19.8118C19.9951 63.2847 20.2151 63.017 20.4718 62.819C20.7358 62.621 21.0218 62.522 21.3298 62.522C21.5424 62.522 21.7331 62.5587 21.9018 62.632L21.7258 63.424C21.6378 63.3947 21.5571 63.3727 21.4838 63.358C21.4104 63.3433 21.3188 63.336 21.2088 63.336C20.9814 63.336 20.7431 63.4277 20.4938 63.611C20.2518 63.7943 20.0391 64.1133 19.8558 64.568V68H18.9538ZM22.7672 68V62.654H23.6692V68H22.7672ZM23.2292 61.554C23.0532 61.554 22.9029 61.499 22.7782 61.389C22.6609 61.279 22.6022 61.1397 22.6022 60.971C22.6022 60.795 22.6609 60.6557 22.7782 60.553C22.9029 60.443 23.0532 60.388 23.2292 60.388C23.4052 60.388 23.5519 60.443 23.6692 60.553C23.7939 60.6557 23.8562 60.795 23.8562 60.971C23.8562 61.1397 23.7939 61.279 23.6692 61.389C23.5519 61.499 23.4052 61.554 23.2292 61.554ZM27.8393 68.132C27.5899 68.132 27.3296 68.0733 27.0583 67.956C26.7943 67.8313 26.5449 67.6627 26.3103 67.45H26.2773L26.2003 68H25.4743V60.168H26.3763V62.302L26.3543 63.27C26.5963 63.0573 26.8603 62.8813 27.1463 62.742C27.4323 62.5953 27.7256 62.522 28.0263 62.522C28.3709 62.522 28.6753 62.588 28.9393 62.72C29.2033 62.8447 29.4233 63.028 29.5993 63.27C29.7826 63.5047 29.9183 63.7907 30.0063 64.128C30.1016 64.458 30.1493 64.8283 30.1493 65.239C30.1493 65.6937 30.0869 66.1007 29.9623 66.46C29.8376 66.8193 29.6689 67.1237 29.4563 67.373C29.2436 67.6223 28.9979 67.813 28.7193 67.945C28.4406 68.0697 28.1473 68.132 27.8393 68.132ZM27.6853 67.373C27.9053 67.373 28.1069 67.3253 28.2903 67.23C28.4809 67.1273 28.6423 66.988 28.7743 66.812C28.9136 66.6287 29.0199 66.405 29.0933 66.141C29.1739 65.877 29.2143 65.58 29.2143 65.25C29.2143 64.9567 29.1886 64.689 29.1373 64.447C29.0859 64.205 29.0016 63.9997 28.8843 63.831C28.7743 63.655 28.6276 63.5193 28.4443 63.424C28.2683 63.3287 28.0556 63.281 27.8063 63.281C27.3736 63.281 26.8969 63.523 26.3763 64.007V66.812C26.6109 67.0173 26.8419 67.164 27.0693 67.252C27.3039 67.3327 27.5093 67.373 27.6853 67.373ZM33.1163 68.132C32.5443 68.132 32.1263 67.956 31.8623 67.604C31.6057 67.252 31.4773 66.7313 31.4773 66.042V62.654H32.3903V65.921C32.3903 66.427 32.4673 66.7937 32.6213 67.021C32.7827 67.241 33.0393 67.351 33.3913 67.351C33.67 67.351 33.9157 67.2813 34.1283 67.142C34.341 66.9953 34.5757 66.7643 34.8323 66.449V62.654H35.7343V68H34.9863L34.9093 67.164H34.8763C34.627 67.4573 34.363 67.692 34.0843 67.868C33.813 68.044 33.4903 68.132 33.1163 68.132ZM39.2207 68.132C38.9347 68.132 38.6927 68.088 38.4947 68C38.3041 67.912 38.1464 67.791 38.0217 67.637C37.9044 67.483 37.8201 67.296 37.7687 67.076C37.7174 66.856 37.6917 66.614 37.6917 66.35V63.391H36.8997V62.709L37.7357 62.654L37.8457 61.158H38.6047V62.654H40.0457V63.391H38.6047V66.361C38.6047 66.691 38.6634 66.9477 38.7807 67.131C38.9054 67.307 39.1217 67.395 39.4297 67.395C39.5251 67.395 39.6277 67.3803 39.7377 67.351C39.8477 67.3217 39.9467 67.2887 40.0347 67.252L40.2107 67.934C40.0641 67.9853 39.9027 68.0293 39.7267 68.066C39.5581 68.11 39.3894 68.132 39.2207 68.132ZM43.2711 68.132C42.9118 68.132 42.5745 68.0697 42.2591 67.945C41.9511 67.813 41.6798 67.6297 41.4451 67.395C41.2178 67.153 41.0381 66.8597 40.9061 66.515C40.7741 66.1703 40.7081 65.778 40.7081 65.338C40.7081 64.898 40.7741 64.5057 40.9061 64.161C41.0455 63.809 41.2251 63.512 41.4451 63.27C41.6725 63.028 41.9291 62.8447 42.2151 62.72C42.5011 62.588 42.7981 62.522 43.1061 62.522C43.4435 62.522 43.7441 62.5807 44.0081 62.698C44.2795 62.8153 44.5031 62.984 44.6791 63.204C44.8625 63.424 45.0018 63.688 45.0971 63.996C45.1925 64.304 45.2401 64.6487 45.2401 65.03C45.2401 65.1253 45.2365 65.2207 45.2291 65.316C45.2291 65.404 45.2218 65.481 45.2071 65.547H41.5991C41.6358 66.119 41.8118 66.5737 42.1271 66.911C42.4498 67.241 42.8678 67.406 43.3811 67.406C43.6378 67.406 43.8725 67.3693 44.0851 67.296C44.3051 67.2153 44.5141 67.1127 44.7121 66.988L45.0311 67.582C44.7965 67.7287 44.5361 67.857 44.2501 67.967C43.9641 68.077 43.6378 68.132 43.2711 68.132ZM41.5881 64.898H44.4481C44.4481 64.3553 44.3308 63.9447 44.0961 63.666C43.8688 63.38 43.5461 63.237 43.1281 63.237C42.9375 63.237 42.7541 63.2737 42.5781 63.347C42.4095 63.4203 42.2555 63.5303 42.1161 63.677C41.9768 63.8163 41.8595 63.9887 41.7641 64.194C41.6761 64.3993 41.6175 64.634 41.5881 64.898Z"
                            fill="#A71931"
                        />
                    </svg>
                    to Enter Data
                </h2>
                <ol>
                    <li>Click on the + Attribute card to open it.</li>
                    <li>
                        Type in the names of your attributes (like Name, Age, or
                        Color) inside the card.
                    </li>
                </ol>
            </div>
        </div>
    );
};

const ElemPlay = React.forwardRef(
    (
        {
            Dyn,
            dynElemPlayContainer,
            onSwitchToPlotView,
            reduceCaseCardWidth,
            editable,
            toggleTableFullView,
            toolsContainer,
            onCaptureImage,
        },
        ref
    ) => {
        const [showBanner, setShowBanner] = useState(
            (editable ? Dyn.dataSet.getNumAttributes() - 1 : -1) === 0
        );
        const [isEditing, setIsEditing] = useState(false);
        const onBannerClick = useCallback(() => {
            dynElemPlayContainer.setEditModeOn();
        }, [dynElemPlayContainer]);

        useEffect(() => {
            const subscriptions = [];
            Dyn.mediatorLocalSubscribe(
                subscriptions,
                "elemPlayContainer:editModeOn",
                (data) => {
                    setShowBanner(false);
                    setIsEditing(true);
                }
            );
            Dyn.mediatorLocalSubscribe(
                subscriptions,
                "elemPlayContainer:editModeOff",
                (data) => {
                    setIsEditing(false);
                }
            );
            return () => {
                Dyn.mediatorLocalRemoveAll(subscriptions);
            };
        }, [Dyn]);

        return (
            <div
                className={
                    "tde-elem-play-wrapper" +
                    (reduceCaseCardWidth ? " tde-with-reduced-card" : "") +
                    (isEditing ? " tde-elem-editing" : "")
                }
            >
                <div className="tde-fill">
                    <CaseCardOutline />
                    {(isEditing || showBanner) && (
                        <div className="tde-d-flex tde-elem-play-header">
                            <h2
                                className="tde-h2 tde-mt-3 tde-flex-1 tde-text-center tde-text-uppercase"
                                style={{ fontWeight: "bold" }}
                            >
                                Insert Data Tuva Jr.
                            </h2>
                        </div>
                    )}
                    {!isEditing && !showBanner && (
                        <Header
                            Dyn={Dyn}
                            toolsContainer={toolsContainer}
                            dynElemPlayContainer={dynElemPlayContainer}
                            onFlip={onSwitchToPlotView}
                            onReset={() => dynElemPlayContainer.resetPlay()}
                            onStackClick={() =>
                                dynElemPlayContainer.onStackClick()
                            }
                            onIconsClick={() =>
                                dynElemPlayContainer.onIconsClick()
                            }
                            onCountClick={() =>
                                dynElemPlayContainer.onCountClick()
                            }
                            onCaptureImage={onCaptureImage}
                            startStopAnnotationClick={(args) => dynElemPlayContainer.startStopAnnotationClick(args)}
                            clearAllAnnotations={() => dynElemPlayContainer.clearAllAnnotations()}
                        />
                    )}
                    <div
                        className="tde-plotview-wrapper tde-fill"
                        ref={ref}
                        tabIndex="0"
                        role="region"
                        aria-label="Plot Area"
                    >
                        <PlotViewLoadingComponent Dyn={Dyn} />
                    </div>
                    {showBanner && (
                        <ElemPlayEditableBanner onClick={onBannerClick} />
                    )}
                    {!!isEditing && (
                        <div className="tde-elem-play-footer tde-text-center">
                            <button
                                className="tde-table-toggle-btn"
                                onClick={toggleTableFullView}
                            >
                                <i className="tde-i tde-i-table"></i>&nbsp;
                                <span>Table View</span>
                            </button>
                            <button
                                className="tde-save-btn"
                                onClick={() => {
                                    // Save data will be called from CaseTableComponent which listens to the edit mode on or off mediator event
                                    dynElemPlayContainer.setEditModeOff();
                                }}
                            >
                                <i className="tde-i tde-i-floppy-disk tde-s2"></i>
                                &nbsp;
                                <span>Save Data</span>
                            </button>
                        </div>
                    )}
                    {!isEditing &&
                        !showBanner &&
                        dynElemPlayContainer?.canShowPlotControls && (
                            <Footer
                                Dyn={Dyn}
                                type={dynElemPlayContainer?.state.plot}
                                attr={dynElemPlayContainer?.state.attribute}
                                onGroupBy={(attr) =>
                                    dynElemPlayContainer.groupBy(attr)
                                }
                                onOrderBy={(attr) =>
                                    dynElemPlayContainer.orderBy(attr)
                                }
                            />
                        )}
                </div>
            </div>
        );
    }
);

export default ElemPlay;
